import { render } from "./PopupPDF.vue?vue&type=template&id=670da7ba&scoped=true"
import script from "./PopupPDF.vue?vue&type=script&lang=js"
export * from "./PopupPDF.vue?vue&type=script&lang=js"

import "./PopupPDF.vue?vue&type=style&index=0&id=670da7ba&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670da7ba"]])

export default __exports__